export const removeSpace = (string: string): string => {
  return string?.toLowerCase().replace(/\s/g, "");
};

export const addAsterisk = (label: string, isRequired: boolean): string => {
  return isRequired ? label + " *" : label;
};

export const extractFileType = (file: File) => {
  return file.name.split(".").pop();
};

export const getDateOnly = (date: Date | string) => {
  return date instanceof Date ? date.toISOString().split("T")[0] : date.split("T")[0];
};

export const getName = <T extends { id: string; name: string }>(
  itemViews: T[],
  linkId: string,
): string => {
  return itemViews.find((item) => item.id === linkId)?.name;
};

export const isAllLowerCase = (text: string) => {
  return /^[a-z]+$/.test(text);
};

export const isCamelCase = (text: string) => {
  return /^[a-z]+([A-Z][a-z]+)+$/.test(text);
};
